import MultiselectPicklist from './MultiselectPicklist';

export * from './MultiselectPicklist';
export default MultiselectPicklist;
